module.exports = __webpack_public_path__ + "static/media/hoodwink.7dda190b.png";